/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlMuteRequestStatus = {
    Requested: 'requested',
    Approved: 'approved',
    Rejected: 'rejected',
    Cancelled: 'cancelled'
} as const;
export type ControlMuteRequestStatus = typeof ControlMuteRequestStatus[keyof typeof ControlMuteRequestStatus];


export function ControlMuteRequestStatusFromJSON(json: any): ControlMuteRequestStatus {
    return ControlMuteRequestStatusFromJSONTyped(json, false);
}

export function ControlMuteRequestStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlMuteRequestStatus {
    return json as ControlMuteRequestStatus;
}

export function ControlMuteRequestStatusToJSON(value?: ControlMuteRequestStatus | null): any {
    return value as any;
}

